import { proxy } from "valtio";

type StoreType = {
    numberActive: number;
    numberArchived: number;
    isEdited: boolean;
    isPlusIconClicked: boolean;
    selectedApplicationSco: any[];
    isAddPeripheralClicked: boolean;
    modify: boolean;
    isActionsClicked: boolean;
    actions: () => void;
    validationAction: (() => void) | Record<string, any>;
    isModesModalPublishOpened: boolean;
};

export const store = proxy<StoreType>({
    numberActive: 0,
    numberArchived: 0,
    isEdited: false,
    isPlusIconClicked: false,
    selectedApplicationSco: [],
    isAddPeripheralClicked: false,
    isActionsClicked: false,
    actions: () => {},
    validationAction: {},
    modify: false,
    isModesModalPublishOpened: false,
});

export function setModify(modify: boolean): void {
    store.modify = modify;
}
export function setNumberActive(numberActive: number): void {
    store.numberActive = numberActive;
}
export function setNumberArchived(numberArchived: number): void {
    store.numberArchived = numberArchived;
}
export function setIsEdited(isEdited: boolean): void {
    store.isEdited = isEdited;
}
export function setIsPlusIconClicked(isPlusIconClicked: boolean): void {
    store.isPlusIconClicked = isPlusIconClicked;
}
export function setSelectedApplicationSco(selectedApplicationSco: any[]): any {
    store.selectedApplicationSco = selectedApplicationSco;
}
export function setIsAddPeripheralClicked(isAddPeripheralClicked: boolean) {
    store.isAddPeripheralClicked = isAddPeripheralClicked;
}
export function setIsActionsClicked(isActionsClicked: boolean): any {
    store.isActionsClicked = isActionsClicked;
}
export function setValidationAction(validationAction: (() => void) | Record<string, any>): void {
    store.validationAction = validationAction;
}
export function setActions(actions: () => void): void {
    store.actions = actions;
}
export function setIsModesModalPublishOpened(isModesModalPublishOpened: boolean): void {
    store.isModesModalPublishOpened = isModesModalPublishOpened;
}

export default store;
